import React from 'react';
import PropTypes from 'prop-types';

const RegisterMessage = ({ title, content, className }) => (
    <div className={className}>
        {title && <h2 className="text-lg font-medium text-gray-base leading-tight">{title}</h2>}
        <p className="text-base leading-loose text-gray-light mt-2">{content}</p>
    </div>
);

RegisterMessage.propTypes = {
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
};

RegisterMessage.defaultProps = {
    title: '',
    className: '',
};

export default RegisterMessage;
